import axios from '@/js/lib/helper/axios';
import { toCamelCaseKeys } from '@/js/lib/helper/localize-keys';
import { updateToken } from '@/js/lib/api/v1/update_token';

export const agree = async ({ settingId }: { settingId: number }): Promise<void> => {
  const token = await updateToken();
  const params = new URLSearchParams();
  params.append('setting_id', String(settingId));
  params.append('token', token);
  await axios.post('/api/account/agree', params);
};

export const confirmEmail = async ({ next }: { next?: string } = {}): Promise<void> => {
  const token = await updateToken();
  await axios.post('/api/account/confirm-email', {
    next,
    token,
  });
};

export const quitAccount = async (): Promise<void> => {
  const token = await updateToken();
  await axios.delete(`/api/my/account`, {
    data: {
      token,
    },
  });
};

export interface ContactData {
  lastName: string;
  firstName: string;
  zipcode: string;
  prefecture: string;
  city: string;
  street1: string;
  street2: string;
  phoneNumber: string;
}

export const getContact = async (): Promise<{ contact: ContactData }> => {
  const res = await axios.get('/api/my/contact');
  return toCamelCaseKeys(res.data);
};

export const updateContact = async ({ lastName, firstName, zipcode, prefecture, city, street1, street2, phoneNumber }: ContactData): Promise<void> => {
  const token = await updateToken();
  await axios.post('/api/my/contact', {
    last_name: lastName,
    first_name: firstName,
    zipcode,
    prefecture,
    city,
    street_1: street1,
    street_2: street2,
    phone_number: phoneNumber,
    token,
  });
};

export interface EmailData {
  email: string;
  password: string;
}

export const updateEmail = async ({ email, password }: EmailData): Promise<void> => {
  const token = await updateToken();
  await axios.post('/api/my/email', {
    email,
    password,
    token,
  });
};

interface PasswordData {
  currentPassword: string;
  newPassword: string;
}

export const updatePassword = async ({ currentPassword, newPassword }: PasswordData): Promise<void> => {
  const token = await updateToken();
  await axios.post('/api/my/password', {
    current_password: currentPassword,
    new_password: newPassword,
    token,
  });
};
